import { render, staticRenderFns } from "./refMUCard.vue?vue&type=template&id=223e43f9&scoped=true"
import script from "./refMUCard.vue?vue&type=script&lang=js"
export * from "./refMUCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223e43f9",
  null
  
)

export default component.exports